import { render, staticRenderFns } from "./visits.vue?vue&type=template&id=0e74da8c&scoped=true&"
import script from "./visits.vue?vue&type=script&lang=js&"
export * from "./visits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e74da8c",
  null
  
)

export default component.exports